module.exports = "table{\r\n    width:80%;\r\n    left:10%;\r\n    position: absolute;\r\n    border:1px solid #288;\r\n}\r\ntd{\r\n    border:1px solid #288;\r\n}\r\nth{\r\n    border:1px solid #288;\r\n}\r\ntr{\r\n    border:1px solid #288;\r\n}\r\n.table thead th{\r\n    border:1px solid #288;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/lines/lines.component.css
// module id = ./src/app/lines/lines.component.css
// module chunks = main